import { useEffect, useState } from "react";
import { getRealtimeSessionId, realtimeClient } from "@/lib/realtimeClient";
import {
  incomingCallFromPayload,
  incomingCallSourceSessionId,
  type IncomingCallNotice,
} from "@/features/incomingCall/incomingCall";

export function useIncomingCallNotice(): {
  call: IncomingCallNotice | null;
  dismiss: () => void;
} {
  const [call, setCall] = useState<IncomingCallNotice | null>(null);

  useEffect(() => {
    return realtimeClient.addListener({
      events: ["incoming_call"],
      fallbackIntervalMs: 86_400_000,
      onChange: (payload) => {
        const notice = incomingCallFromPayload(payload?.data);
        if (!notice) return;
        const sourceSessionId = incomingCallSourceSessionId(payload?.data);
        const ownSessionId = getRealtimeSessionId();
        if (sourceSessionId && ownSessionId && sourceSessionId === ownSessionId) return;
        setCall(notice);
      },
    });
  }, []);

  return { call, dismiss: () => setCall(null) };
}
